import { memo } from 'react';
import { AccordionIdentityCard as AccordionIdentityCardVM } from 'shell/view-models/accordion-identity-card';
import { Divider, Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { FormikErrors, FormikTouched } from 'formik';

interface IdentityCardProps {
  disabled?: boolean;
  values?: AccordionIdentityCardVM;
  onChange: (
    key: keyof AccordionIdentityCardVM,
    value: AccordionIdentityCardVM[keyof AccordionIdentityCardVM]
  ) => void;
  isEditMode?: boolean;
  errors?: FormikErrors<AccordionIdentityCardVM>;
  touched?: FormikTouched<AccordionIdentityCardVM>;
}

const MunicipalityReleaseComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
  errors,
  touched,
}: IdentityCardProps): React.ReactElement => {
  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Comune rilascio</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={7}>
        <MunicipalityList
          label="Comune *"
          aria-label="Comune"
          value={values?.municipality || null}
          disabled={isEditMode ? false : disabled}
          onChange={(value) => {
            onChange('municipality', value);
          }}
          error={touched?.municipality && Boolean(errors?.municipality)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Provincia"
          id="province"
          inputProps={{
            maxLength: '2',
          }}
          aria-label="Provincia"
          fullWidth
          onChange={(event) => {
            onChange('province', event?.target.value);
          }}
          value={values?.municipality?.province || ''}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={7}>
        <PmiTextField
          label="Località"
          aria-label="Località"
          id="location"
          fullWidth
          onChange={(event) => {
            onChange('location', event?.target.value);
          }}
          inputProps={{
            maxLength: '120',
          }}
          value={values?.location || ''}
          disabled={isEditMode ? false : disabled}
          helperText={errors?.location}
          error={touched?.location && Boolean(errors?.location)}
        />
      </Grid>
    </Grid>
  );
};

MunicipalityReleaseComponent.displayName = 'Municipality Release component';

const MunicipalityRelease = memo(MunicipalityReleaseComponent);

export default MunicipalityRelease;
